module.exports = __webpack_public_path__ + "static/media/IMG_0001.d12ebf58.jpg";